/* tslint:disable */
/* eslint-disable */
/* Code generated by ng-openapi-gen DO NOT EDIT. */

import { HttpClient, HttpContext, HttpResponse } from '@angular/common/http';
import { Observable } from 'rxjs';
import { filter, map } from 'rxjs/operators';

import { PartsAgreementRestResponse } from '../../models/parts-agreement-rest-response';
import { UpdatePartsAgreementRestRequest } from '../../models/update-parts-agreement-rest-request';
import { RequestBuilder } from '../../request-builder';
import { StrictHttpResponse } from '../../strict-http-response';

export interface UpdatePartsAgreement$Params {
  id: number;
  body: UpdatePartsAgreementRestRequest;
}

export function updatePartsAgreement(
  http: HttpClient,
  rootUrl: string,
  params: UpdatePartsAgreement$Params,
  context?: HttpContext,
): Observable<StrictHttpResponse<PartsAgreementRestResponse>> {
  const rb = new RequestBuilder(rootUrl, updatePartsAgreement.PATH, 'put');
  if (params) {
    rb.path('id', params.id, {});
    rb.body(params.body, 'application/json');
  }

  return http.request(rb.build({ responseType: 'json', accept: 'application/json', context })).pipe(
    filter((r: any): r is HttpResponse<any> => r instanceof HttpResponse),
    map((r: HttpResponse<any>) => {
      return r as StrictHttpResponse<PartsAgreementRestResponse>;
    }),
  );
}

updatePartsAgreement.PATH = '/parts-agreement/{id}';
